export const UNDERSTANDING_SECTION = "UNDERSTANDING_SECTION";
export const UNDERSTANDING_SECTION_DISPLAY_DATA = "UNDERSTANDING_SECTION_DISPLAY_DATA";
export const UNDERSTANDING_SECTION_ERROR = "UNDERSTANDING_SECTION_ERROR";
export const UNDERSTANDINGSECTION_HIDE_ERROR = "UNDERSTANDING_SECTION_HIDE_ERROR";
export const UNDERSTANDING_SECTION_START_LOADER = "UNDERSTANDING_SECTION_START_LOADER";
export const UNDERSTANDING_SECTION_STOP_LOADER = "UNDERSTANDING_SECTION_STOP_LOADER";
